import { BookOpen, HeartPulse, Pill, ClipboardList, UserPlus, LogOut, Droplets, ClipboardCheck } from 'lucide-react';
import { NOTE_TYPE_LABELS } from '../../constants/schemas';
import { getNoteTypeLabel } from '../../utils/noteTypeLabels';
import { useLanguage } from '../../contexts/LanguageContext';

const NOTE_TYPE_ICONS = {
  progress_note: BookOpen,
  vitals: HeartPulse,
  medication_admin: Pill,
  fluid_balance: Droplets,
  care_plan: ClipboardCheck,
  handover: ClipboardList,
  admission: UserPlus,
  discharge: LogOut,
};

export default function NoteTypeSectionHeader({ noteType }) {
  const { language } = useLanguage();
  const Icon = NOTE_TYPE_ICONS[noteType] || BookOpen;
  const label = getNoteTypeLabel(noteType, language) || NOTE_TYPE_LABELS[noteType] || noteType;

  return (
    <div className="mb-2.5 flex items-center gap-2">
      <Icon className="h-5 w-5 shrink-0 text-primary" strokeWidth={2} />
      <h2 className="text-base font-bold text-gray-900">{label}</h2>
    </div>
  );
}
